import { apiGeneric } from "src/core/helpers/api"
const ApiGeneric = ({
  request,
  data,
  successCallBack,
  errorCallBack,
  customHeader,
}) => {
  apiGeneric({
    method: request.method || "POST",
    url: request.url || `${request.path}/${request.name}` || "NoApiUrl",
    data,
    customHeader: customHeader,
  })
    .then(v => {
      if (successCallBack) {
        successCallBack(v)
      }
    })
    .catch(e => {
      if (errorCallBack) {
        errorCallBack(e)
      }
    })
}
export { ApiGeneric }
